import { services } from '../Functions'
import { ServiceElement } from './ServiceElement'

const ServiceSections = (props) => (
  <div className="admin-coefficient-sections">
    {services.map(({ id, ...service }) => (
      <ServiceElement key={id} coefficient={props?.[id]?.coefficient} service={service} />
    ))}
  </div>
)

export default ServiceSections
